import axios from 'axios';
import moment from 'moment';
import getCookie from '#/utils/cookies.js';

import 'moment/locale/pt-br';
import { getBaseUrlWithCustomerPrefix } from './serviceCommons';

moment.locale('pt-BR');

const BASE_URL = getBaseUrlWithCustomerPrefix(process.env.REACT_APP_URL_API);

function parseFilters(localFilters) {
  const allFilter = Object.values(localFilters);

  const businessUnitIds = allFilter[0].length
    ? { businessUnitIds: [...allFilter[0]] }
    : null;
  const clientIds = allFilter[1].length ? { clientIds: [...allFilter[1]] } : null;
  const workplaceIds = allFilter[2].length
    ? { workplaceIds: [...allFilter[2]] }
    : null;
  const companyIds = allFilter[3].length
    ? { companyIds: [...allFilter[3]] }
    : null;

  return {
    ...businessUnitIds,
    ...clientIds,
    ...workplaceIds,
    ...companyIds,
    personTemplate: localFilters.personTemplate
  };
}

function parseWidgetBindDtos(widgetBindDtos) {
  if (!widgetBindDtos || (widgetBindDtos && !widgetBindDtos.length)) return {}

  const clientsFilter = widgetBindDtos.find(filter => filter.entityName === "CLIENT")
  const businessUnitsFilter = widgetBindDtos.find(filter => filter.entityName === "BUSINESS_UNIT")
  const workplacesFilter = widgetBindDtos.find(filter => filter.entityName === "WORKPLACE")
  const companiesFilters = widgetBindDtos.find(filter => filter.entityName === "COMPANY")
  const timeTrackingTypesFilters = widgetBindDtos.find(filter => filter.entityName === "TIME_TRACKING_TYPE")
  const serviceTypesFilters = widgetBindDtos.find(filter => filter.entityName === "SERVICE_TYPE")
  const absenceSituationFilters = widgetBindDtos.find(filter => filter.entityName === "ABSENCE_SITUATION")
  const eventsFilters = widgetBindDtos.find(filter => filter.entityName === "EVENT")
  const occurrenceReasonsFilters = widgetBindDtos.find(filter => filter.entityName === "OCCURRENCE_REASON")
  const personsFilters = widgetBindDtos.find(filter => filter.entityName === "PERSON")
  const areasFilters = widgetBindDtos.find(filter => filter.entityName === "AREA")
  const approvalReasonFilters = widgetBindDtos.find(filter => filter.entityName === "APPROVAL_REASON")

  return  {
    clientIds: (clientsFilter && clientsFilter.dashboardWidgetBindDtos) ? [...clientsFilter.dashboardWidgetBindDtos.map(client => client.value)] : null,
    businessUnitIds: (businessUnitsFilter && businessUnitsFilter.dashboardWidgetBindDtos) ? [...businessUnitsFilter.dashboardWidgetBindDtos.map(businessUnit => businessUnit.value)] : null,
    workplaceIds: (workplacesFilter && workplacesFilter.dashboardWidgetBindDtos) ? [...workplacesFilter.dashboardWidgetBindDtos.map(workplace => workplace.value)] : null,
    companyIds: (companiesFilters && companiesFilters.dashboardWidgetBindDtos) ? [...companiesFilters.dashboardWidgetBindDtos.map(company => company.value)] : null,
    timeTrackingTypeIds: (timeTrackingTypesFilters && timeTrackingTypesFilters.dashboardWidgetBindDtos) ? [...timeTrackingTypesFilters.dashboardWidgetBindDtos.map(timeTrackingType => timeTrackingType.value)] : null,
    serviceTypeIds: (serviceTypesFilters && serviceTypesFilters.dashboardWidgetBindDtos) ? [...serviceTypesFilters.dashboardWidgetBindDtos.map(serviceType => serviceType.value)] : null,
    absenceSituationIds: (absenceSituationFilters && absenceSituationFilters.dashboardWidgetBindDtos) ? [...absenceSituationFilters.dashboardWidgetBindDtos.map(absenceSituation => absenceSituation.value)] : null,
    eventIds: (eventsFilters && eventsFilters.dashboardWidgetBindDtos) ? [...eventsFilters.dashboardWidgetBindDtos.map(event => event.value)] : null,
    occurrenceReasonIds: (occurrenceReasonsFilters && occurrenceReasonsFilters.dashboardWidgetBindDtos) ? [...occurrenceReasonsFilters.dashboardWidgetBindDtos.map(occurrenceReason => occurrenceReason.value)] : null,
    personIds: (personsFilters && personsFilters.dashboardWidgetBindDtos) ? [...personsFilters.dashboardWidgetBindDtos.map(person => person.value)] : null,
    areaIds: (areasFilters && areasFilters.dashboardWidgetBindDtos) ? [...areasFilters.dashboardWidgetBindDtos.map(area => area.value)] : null,
    approvalReasonIds: (approvalReasonFilters && approvalReasonFilters.dashboardWidgetBindDtos) ? [...approvalReasonFilters.dashboardWidgetBindDtos.map(approvalReason => approvalReason.value)] : null,
  }
}

const fetchWidget = async (
  { endpointUrl, endpointType },
  filters,
  localFilters,
  date,
  dashboardWidgetId,
  ordination,
  exhibition,
  widgetBindDtos,
  auxiliaryOptionsDto
) => {
  const parsedLocalFilters = parseFilters(localFilters);
  const parsedWidgetBindDtos = parseWidgetBindDtos(widgetBindDtos);
  const body = {
    ...filters,
    clientIds: parsedWidgetBindDtos.clientIds && parsedWidgetBindDtos.clientIds.length !== 0 ? parsedWidgetBindDtos.clientIds: parsedLocalFilters.clientIds ? parsedLocalFilters.clientIds : null,
    businessUnitIds: parsedWidgetBindDtos.businessUnitIds && parsedWidgetBindDtos.businessUnitIds.length !== 0 ? parsedWidgetBindDtos.businessUnitIds: parsedLocalFilters.businessUnitIds ? parsedLocalFilters.businessUnitIds : null,
    workplaceIds: parsedWidgetBindDtos.workplaceIds && parsedWidgetBindDtos.workplaceIds.length !== 0 ? parsedWidgetBindDtos.workplaceIds: parsedLocalFilters.workplaceIds ? parsedLocalFilters.workplaceIds : null,
    companyIds: parsedWidgetBindDtos.companyIds && parsedWidgetBindDtos.companyIds.length !== 0 ? parsedWidgetBindDtos.companyIds: parsedLocalFilters.companyIds ? parsedLocalFilters.companyIds : null,
    timeTrackingTypeIds: parsedWidgetBindDtos.timeTrackingTypeIds && parsedWidgetBindDtos.timeTrackingTypeIds.length !== 0 ? parsedWidgetBindDtos.timeTrackingTypeIds: parsedLocalFilters.timeTrackingTypeIds ? parsedLocalFilters.timeTrackingTypeIds : null,
    serviceTypeIds: parsedWidgetBindDtos.serviceTypeIds && parsedWidgetBindDtos.serviceTypeIds.length !== 0 ? parsedWidgetBindDtos.serviceTypeIds: parsedLocalFilters.serviceTypeIds ? parsedLocalFilters.serviceTypeIds : null,
    absenceSituationIds: parsedWidgetBindDtos.absenceSituationIds && parsedWidgetBindDtos.absenceSituationIds.length !== 0 ? parsedWidgetBindDtos.absenceSituationIds: parsedLocalFilters.absenceSituationIds ? parsedLocalFilters.absenceSituationIds : null,
    eventIds: parsedWidgetBindDtos.eventIds && parsedWidgetBindDtos.eventIds.length !== 0 ? parsedWidgetBindDtos.eventIds: parsedLocalFilters.eventIds ? parsedLocalFilters.eventIds : null,
    occurrenceReasonIds: parsedWidgetBindDtos.occurrenceReasonIds && parsedWidgetBindDtos.occurrenceReasonIds.length !== 0 ? parsedWidgetBindDtos.occurrenceReasonIds: parsedLocalFilters.occurrenceReasonIds ? parsedLocalFilters.occurrenceReasonIds : null,
    personIds: parsedWidgetBindDtos.personIds && parsedWidgetBindDtos.personIds.length !== 0 ? parsedWidgetBindDtos.personIds: parsedLocalFilters.personIds ? parsedLocalFilters.personIds : null,
    areaIds: parsedWidgetBindDtos.areaIds && parsedWidgetBindDtos.areaIds.length !== 0 ? parsedWidgetBindDtos.areaIds: parsedLocalFilters.areaIds ? parsedLocalFilters.areaIds : null,
    approvalReasonIds: parsedWidgetBindDtos.approvalReasonIds && parsedWidgetBindDtos.approvalReasonIds.length !== 0 ? parsedWidgetBindDtos.approvalReasonIds: parsedLocalFilters.approvalReasonIds ? parsedLocalFilters.approvalReasonIds : null,
    startDate: date.startDate.valueOf(),
    finishDate: date.endDate.valueOf(),
    dashboardWidgetId: dashboardWidgetId,
    personTemplate: parsedLocalFilters.personTemplate,
    ordination: ordination,
    exhibition: exhibition,
    auxiliaryOptionsDto: auxiliaryOptionsDto !== null ? auxiliaryOptionsDto : null
  };

  return axios({
    method: endpointType,
    url: `${BASE_URL}${endpointUrl}`,
    headers: { Authorization: `Bearer ${getCookie('access_token')}` },
    data: body,
  });
};

export default fetchWidget;
